module.exports = __webpack_public_path__ + "static/media/logo.92f44f40.png";